import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {AddressModel} from '../../../../common/entity/address.model';


export class  PartnerAddressModel{
    type: LovValueSummary;
    address: AddressModel;
    label: string;
    id: number;
}

export enum PartnerAddressType {
    INVOICE = 'PARTNER_ADDRESS_INVOICE',
    MAIN = 'PARTNER_ADDRESS_MAIN',
    DELIVERY = 'PARTNER_ADDRESS_DELIVERY',
}